import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=6e6ddc5d&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=js&"
export * from "./MyAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=6e6ddc5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ddc5d",
  null
  
)

component.options.__file = "MyAccount.vue"
export default component.exports